export default function (color1: string, color2: string) {
  function hexToRGB(hex: string): { r: number; g: number; b: number; a?: number } | null {
    const rgbPattern = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    const rgbaPattern = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

    const rgbResult = rgbPattern.exec(hex);
    const rgbaResult = rgbaPattern.exec(hex);
    // console.log(rgbResult);

    if (rgbaResult) {
      const r = parseInt(rgbaResult[1], 16);
      const g = parseInt(rgbaResult[2], 16);
      const b = parseInt(rgbaResult[3], 16);
      const a = parseInt(rgbaResult[4], 16) / 255; // Normalize alpha to the range [0, 1]

      return { r, g, b, a };
    } else if (rgbResult) {
      const r = parseInt(rgbResult[1], 16);
      const g = parseInt(rgbResult[2], 16);
      const b = parseInt(rgbResult[3], 16);

      return { r, g, b };
    }

    return null;
  }

  function calculateLuminance(rgb: { r: number; g: number; b: number; a?: number }): number {
    const { r, g, b, a } = rgb;

    const sR = r / 255;
    const sG = g / 255;
    const sB = b / 255;

    const transformedR = sR <= 0.03928 ? sR / 12.92 : Math.pow((sR + 0.055) / 1.055, 2.4);
    const transformedG = sG <= 0.03928 ? sG / 12.92 : Math.pow((sG + 0.055) / 1.055, 2.4);
    const transformedB = sB <= 0.03928 ? sB / 12.92 : Math.pow((sB + 0.055) / 1.055, 2.4);

    const luminance = 0.2126 * transformedR + 0.7152 * transformedG + 0.0722 * transformedB;

    if (a !== undefined && a < 1) {
      return luminance * a;
    }
    return luminance;
  }
  function calculateContrast(): number {
    const rgb1 = hexToRGB(color1);
    const rgb2 = hexToRGB(color2);

    if (rgb1 === null || rgb2 === null) {
      throw new Error('Invalid color code.');
    }

    const luminance1 = calculateLuminance(rgb1);
    const luminance2 = calculateLuminance(rgb2);

    const contrast = (Math.max(luminance1, luminance2) + 0.05) / (Math.min(luminance1, luminance2) + 0.05);

    return contrast;
  }

  return {
    hexToRGB,
    calculateContrast,
  };
}
